import { Router, Outlet } from '@tanstack/react-location'
import { location, routes } from 'MediaManager/routes'
import './styles.scss'
import { ToastContainer } from 'react-toastify'
function App() {
  return (
    <div className="h-screen overflow-hidden min-w-[1366px] overflow-x-auto bg-[#F3F4F6]">
      <ToastContainer position='bottom-center' />
      <Router location={location} routes={routes}>
        <Outlet />
      </Router>
    </div>
  )
}

export default App
